import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { 
  FiX, FiArrowLeft, FiCheckCircle, FiMaximize, FiLayout, FiTruck, FiWifi,
  FiStar, FiClock, FiMapPin, FiDroplet, FiBriefcase, FiActivity, FiSlash, 
  FiSquare, FiWind, FiZap, FiHome, FiAlertTriangle, FiShield, 
  FiBell, FiCoffee, FiRefreshCw, FiBox, FiCpu
} = FiIcons;

const Portfolio = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const heroAsset = "https://res.cloudinary.com/dwumujtpu/image/upload/v1777173721/10-7601_Canada_Ave_Amenities_jbc6bv.webp";

  const galleryItems = [
    { 
      id: 1,
      title: 'Resort Entrance', 
      category: 'Exterior', 
      image: 'https://res.cloudinary.com/dwumujtpu/image/upload/v1777173688/1-7601_Canada_Ave_Amenities_buge9x.jpg',
    }, 
    { 
      id: 2,
      title: 'Lobby Lounge', 
      category: 'Amenities', 
      image: 'https://res.cloudinary.com/dwumujtpu/image/upload/v1777173692/2-7601_Canada_Ave_Amenities_bzdqtr.jpg',
    }, 
    { 
      id: 3,
      title: 'Breakfast Area', 
      category: 'Dining', 
      image: 'https://res.cloudinary.com/dwumujtpu/image/upload/v1777173695/3-7601_Canada_Ave_Amenities_awsdyt.jpg',
    }, 
    { 
      id: 4,
      title: 'Resort Pool', 
      category: 'Pool', 
      image: 'https://res.cloudinary.com/dwumujtpu/image/upload/v1777173699/4-7601_Canada_Ave_Amenities_az08nc.jpg',
    }, 
    { 
      id: 5,
      title: 'Sun Deck', 
      category: 'Pool', 
      image: 'https://res.cloudinary.com/dwumujtpu/image/upload/v1777173703/5-7601_Canada_Ave_Amenities_drwls4.jpg',
    }, 
    { 
      id: 6,
      title: 'Outdoor Lounge', 
      category: 'Amenities', 
      image: 'https://res.cloudinary.com/dwumujtpu/image/upload/v1777173710/7-7601_Canada_Ave_Amenities_hgknah.webp',
    }, 
    { 
      id: 7,
      title: 'Fitness Center', 
      category: 'Wellness', 
      image: 'https://res.cloudinary.com/dwumujtpu/image/upload/v1777173713/8-7601_Canada_Ave_Amenities_yzpfi7.webp',
    }, 
    { 
      id: 8,
      title: 'Arcade Room', 
      category: 'Entertainment', 
      image: 'https://res.cloudinary.com/dwumujtpu/image/upload/v1777173717/9-7601_Canada_Ave_Amenities_hmzla1.webp',
    }, 
    { 
      id: 9,
      title: 'Bar & Grill', 
      category: 'Dining', 
      image: 'https://res.cloudinary.com/dwumujtpu/image/upload/v1777173725/11-7601_Canada_Ave_Amenities_itr3h7.webp',
    }, 
    { 
      id: 10,
      title: 'Conference Room', 
      category: 'Business', 
      image: 'https://res.cloudinary.com/dwumujtpu/image/upload/v1777173728/12-7601_Canada_Ave_Amenities_fx0nmj.webp',
    }, 
    { 
      id: 11,
      title: 'Gift Shop', 
      category: 'Amenities', 
      image: 'https://res.cloudinary.com/dwumujtpu/image/upload/v1777174155/13-7601_Canada_Ave_Amenities_jghahl.jpg',
    }, 
    {
      id: 12,
      title: 'Exterior View',
      category: 'Exterior',
      image: 'https://media-manager-c.questera.ai/greta-media/a9dafbdca7a53505ee8e6c159db427394419e27bea345e5b19b45c8548ba1d55be4babe7870412394b37ceb3edc9196c/images/aW1hZ2Uvd2VicA==/ec12871d12588b52abe96b6c0a9c7a3c.webp'
    }
  ];

  const highlights = [
    { icon: FiWind, title: 'Heating & AC' },
    { icon: FiCpu, title: 'Iron' },
    { icon: FiDroplet, title: 'Soap & Shampoo' },
    { icon: FiZap, title: 'Hair Dryer' },
    { icon: FiHome, title: 'Bed & Bath Essentials' },
    { icon: FiAlertTriangle, title: 'CO Alarm' },
    { icon: FiShield, title: 'Fire Extinguisher' },
    { icon: FiBell, title: 'Smoke Alarm' },
    { icon: FiLayout, title: 'Kitchen Utensils' },
    { icon: FiCoffee, title: 'Coffee Maker' },
    { icon: FiRefreshCw, title: 'Dishwasher' },
    { icon: FiMaximize, title: 'Microwave' },
    { icon: FiBox, title: 'Refrigerator' },
    { icon: FiTruck, title: 'Free Parking' },
    { icon: FiWifi, title: 'Free Wi-Fi' },
    { icon: FiStar, title: 'Pool Views' },
    { icon: FiClock, title: 'Flexible Stays' },
    { icon: FiMapPin, title: 'Walk To I-Drive' },
    { icon: FiDroplet, title: 'Guest Laundry on 4th Floor' },
    { icon: FiBriefcase, title: 'Business Center' },
    { icon: FiActivity, title: 'Gym' },
    { icon: FiSlash, title: 'No Pets Allowed' },
    { icon: FiSquare, title: '542 sq. ft. Suite' },
    { icon: FiMaximize, title: 'Sleeps 6' }
  ];

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') setSelectedImage(null);
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);

  return (
    <div className="pt-32 pb-24 bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Link to="/" className="inline-flex items-center gap-2 group text-black/40 hover:text-black transition-colors mb-12 uppercase text-[10px] font-black tracking-widest outline-none focus:ring-2 focus:ring-black rounded px-2">
          <SafeIcon icon={FiArrowLeft} className="w-4 h-4 group-hover:-translate-x-1 transition-transform" /> Back to Home
        </Link>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 mb-32">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
          >
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-orange text-white text-[10px] font-black uppercase tracking-widest mb-6">
              The Experience
            </span>
            <h1 className="text-6xl md:text-8xl font-serif font-black text-black uppercase tracking-tighter leading-[0.9] mb-8">
              Resort <br /> <span className="text-transparent bg-clip-text bg-gradient-to-r from-black to-black/40 italic">Amenities</span>
            </h1>
            <p className="text-xl text-black/60 leading-relaxed mb-12">
              Everything you need for a perfect Orlando stay. From our tropical pool deck and fitness center to premier guest services and on-site dining, we provide a complete resort lifestyle.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-12">
              {[
                'Tropical Pool Deck',
                'Fitness Center',
                'Game Room/Arcade',
                'Business Center',
                'On-site Laundry'
              ].map((feature, i) => (
                <div key={i} className="flex items-center gap-3">
                  <SafeIcon icon={FiCheckCircle} className="text-accent-orange w-5 h-5" />
                  <span className="text-xs font-black uppercase tracking-widest text-black">{feature}</span>
                </div>
              ))}
            </div>

            <div className="flex gap-12 py-8 border-t border-black/5 overflow-x-auto pb-4">
              {[
                { icon: FiMaximize, label: 'Lobby' },
                { icon: FiLayout, label: 'Dining' },
                { icon: FiTruck, label: 'Parking' },
                { icon: FiWifi, label: 'Wi-Fi' }
              ].map((item, i) => (
                <div key={i} className="text-center flex-shrink-0">
                  <SafeIcon icon={item.icon} className="w-6 h-6 mx-auto mb-2 text-black/20" />
                  <div className="text-[10px] font-black uppercase tracking-widest whitespace-nowrap">{item.label}</div>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="relative aspect-square bg-black rounded-[40px] overflow-hidden group shadow-2xl cursor-pointer"
            onClick={() => setSelectedImage({ image: heroAsset, title: 'Resort Amenities', category: 'Overview' })}
          >
            <img 
              src={heroAsset} 
              className="w-full h-full object-cover opacity-90 transition-transform duration-700 group-hover:scale-105" 
              alt="Tropical pool deck and resort amenities at 7601 Canada Avenue"
            />
          </motion.div>
        </div>

        <section id="gallery">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-8">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="max-w-2xl"
            >
              <div className="flex items-center gap-4 mb-6">
                <span className="h-px w-12 bg-accent-orange"></span>
                <span className="text-accent-orange font-bold tracking-[0.3em] uppercase text-xs">Visual Tour</span>
              </div>
              <h2 className="text-4xl md:text-6xl font-serif font-bold text-black uppercase tracking-tight leading-[0.9]">
                What can you see in our <span className="text-transparent bg-clip-text bg-gradient-to-r from-black to-black/40 italic">lifestyle gallery?</span>
              </h2>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {galleryItems.map((item) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="relative group cursor-pointer"
                onClick={() => setSelectedImage(item)}
              >
                <div className="relative aspect-[4/3] rounded-[2rem] overflow-hidden bg-black/5 group-hover:shadow-2xl transition-all duration-700">
                  <img
                    src={item.image}
                    alt={`${item.title} at 7601 Canada Avenue`}
                    className="w-full h-full object-cover transition-all duration-1000 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                     <span className="text-white text-[10px] font-black uppercase tracking-widest bg-black/40 backdrop-blur-md px-4 py-2 rounded-full">View Large</span>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </section>

        <div className="mt-32 pt-24 border-t border-black/5">
          <div className="mb-16 text-center">
            <span className="text-accent-orange font-black tracking-[0.3em] uppercase text-[10px] mb-4 block">Comprehensive Features</span>
            <h3 style={{ fontSize: '52px' }} className="text-4xl md:text-5xl font-serif font-black text-black uppercase tracking-tighter">Which amenities are included?</h3>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-y-12 gap-x-8">
            {highlights.map((item, i) => (
              <div key={i} className="flex flex-col items-center text-center">
                <div className="w-16 h-16 bg-black text-white rounded-3xl flex items-center justify-center mb-4 hover:bg-accent-orange transition-colors duration-500 hover:rotate-6">
                  <SafeIcon icon={item.icon} className="w-7 h-7" />
                </div>
                <span className="text-[9px] font-black uppercase tracking-widest text-black leading-tight max-w-[120px]">{item.title}</span>
              </div>
            ))}
          </div>
        </div>
        
      </div>

      <AnimatePresence>
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-6 md:p-12"
            onClick={() => setSelectedImage(null)}
            role="dialog"
            aria-modal="true"
          >
            <button 
              className="absolute top-8 right-8 text-white/50 hover:text-white transition-colors z-10 p-2"
              onClick={() => setSelectedImage(null)}
              aria-label="Close"
            >
              <SafeIcon icon={FiX} className="w-8 h-8" />
            </button>
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ type: "spring", damping: 25, stiffness: 200 }}
              className="relative max-w-5xl w-full h-full flex flex-col items-center justify-center px-4"
              onClick={(e) => e.stopPropagation()}
            >
              <img 
                src={selectedImage.image} 
                alt={`${selectedImage.title} at 7601 Canada Avenue`}
                className="max-w-full max-h-[90vh] object-contain rounded-2xl shadow-2xl"
              />
              {selectedImage.title && (
                <div className="mt-6 text-center">
                  <h4 className="text-white text-2xl font-serif font-black uppercase">{selectedImage.title}</h4>
                </div>
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Portfolio;